import {mapActions} from 'vuex';

export var brandMixin = {
    data : () => {
        return {
            brandQuery : {todos:''},
        }
    },
    methods:{
        ...mapActions({getBrandsAPI: 'brandModule/getBrands'}),
    }
}